import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IOutOfOfficeRequest } from '../shared/interfaces/out-of-office/IOutOfOfficeRequest';
import { IPaginatedResponse } from '../shared/interfaces/IPaginatedResponse';
import { IPaginationProps } from '../shared/interfaces/IPaginationProps';
import { PaginationOperations } from '../shared/operations/pagination.operations';
import { IOutOfOfficeRequestCommentCreate } from '../shared/interfaces/out-of-office/IOutOfOfficeRequestComment';

@Injectable({
  providedIn: 'root',
})
export class OutOfOfficeService {
  private readonly http = inject(HttpClient);

  public getOutOfOfficeRequests(
    paginationProps: IPaginationProps,
    requiresAction: boolean,
  ): Observable<IPaginatedResponse<IOutOfOfficeRequest>> {
    const url = `${environment.apiUrl}OutOfOfficeRequest/GetAll`;
    let params = PaginationOperations.getPaginatedResponseQueryParameters(paginationProps);
    if (requiresAction) {
      params = params.set('requiresAction', true);
    }

    return this.http.get<IPaginatedResponse<IOutOfOfficeRequest>>(url, {
      params,
    });
  }

  public getOutOfOfficeRequestById(requestId: number): Observable<IOutOfOfficeRequest> {
    return this.http.get<IOutOfOfficeRequest>(`${environment.apiUrl}OutOfOfficeRequest/GetById/${requestId}`);
  }

  public createOutOfOfficeRequest(request: IOutOfOfficeRequest): Observable<IOutOfOfficeRequest> {
    return this.http.post<IOutOfOfficeRequest>(`${environment.apiUrl}OutOfOfficeRequest/Create`, request);
  }

  public updateOutOfOfficeRequest(request: IOutOfOfficeRequest): Observable<IOutOfOfficeRequest> {
    return this.http.put<IOutOfOfficeRequest>(`${environment.apiUrl}OutOfOfficeRequest/Update/${request.id}`, request);
  }

  public deleteOutOfOfficeRequest(requestId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.apiUrl}OutOfOfficeRequest/Delete/${requestId}`);
  }

  public createOutOfOfficeRequestComment(requestId: number, comment: IOutOfOfficeRequestCommentCreate): Observable<IOutOfOfficeRequest> {
    return this.http.post<IOutOfOfficeRequest>(`${environment.apiUrl}OutOfOfficeRequest/CreateComment/${requestId}`, comment);
  }

  public deleteOutOfOfficeRequestComment(commentId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.apiUrl}OutOfOfficeRequest/DeleteComment/${commentId}`);
  }
}
